<div
  stchPopover
  [stchPopoverArrow]="true"
  [stchPopoverContent]="popoverTemplate"
  [stchPopoverInnerShadow]="true"
  stchPopoverPlacement="right"
  [stchPopoverDisabled]="!minimized"
  stchPopoverTrigger="click"
>
  <app-sidebar-item
    [title]="title"
    icon="sapphire-folders"
    class="rounded hover:bg-hover"
    [depth]="depth ?? 0"
    [expandable]="expandable"
    [expanded]="expanded | lsValue: application : team?.id"
    [minimized]="minimized"
    [active]="currentTeamId === team?.id && sidebarFilter === 'all_folders'"
    [actions]="[
      {
        icon: 'sapphire-plus',
        template: folderQuickFormTemplate,
        until: quickFormPopoverClose,
        appearance: 'dialog',
      },
    ]"
    (onExpand)="expanded.set($event, application, team?.id)"
    (appClick)="selectFilter.emit('all_folders')"
    appSidebarContextMenu="all_folders"
    [appSidebarContextMenuTenantId]="mailboxTenantId"
    [appSidebarContextMenuRail]="teamRail || memberRail"
    [appSidebarContextMenuRailScope]="teamRail ? 'team' : 'mine'"
  >
    <app-context-menu-state-indicator
      appearance="sapphire"
      svgIcon="sapphire-ellipsis"
      appMessagesFoldersListContextMenu
    />
  </app-sidebar-item>
</div>

@if (!minimized && expandable) {
  <div class="collapseable-body" [@heightAnimation]="(expanded | lsValue: application : team?.id) ? 'show' : 'hide'">
    <ng-container *ngTemplateOutlet="contentTemplate" />
  </div>
}

<ng-template #popoverTemplate>
  @if (minimized) {
    <div class="popover-body">
      <ng-container *ngTemplateOutlet="contentTemplate" />
    </div>
  }
</ng-template>

<ng-template #contentTemplate>
  <app-side-bar-folders-tree
    [filters]="filters"
    [team]="team"
    [messagesCount]="messagesCount"
    [mailboxTenantId]="mailboxTenantId"
    [itemCreateFormTemplate]="folderQuickFormTemplate"
  />
</ng-template>

<ng-template #folderQuickFormTemplate let-parentId="parentId">
  <div class="quick-form-container">
    <app-message-folder-quick-form
      [autofocus]="true"
      [parentId]="parentId"
      [inline]="true"
      [showMore]="true"
      [showCancel]="true"
      [mailboxTenantId]="mailboxTenantId"
      (close)="quickFormPopoverClose.next()"
      (more)="handleMore($event)"
    />
  </div>
</ng-template>
